
// input : YYYYMMDD
export function formatDate(date) {
    let [_, y,m,d] =  /(\d{4})(\d{2})(\d{2})/.exec(date);
    return `${d} / ${m} / ${y}`;
}